(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lo-promo-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lo-promo-strip')) customElements.define('lo-promo-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-promo-toggle]');
      this.toggle?.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.play : this.toggle.dataset.pause);
      });
      const active = document.querySelector('lo-perks[data-has-offer="true"]');
      this.querySelectorAll('[data-lo-product-offer]').forEach(link => { link.hidden = !active; });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lo-system"] && !Shopify.designMode) return;
  try {
    const syncProductOffers = () => {
    const active = document.querySelector('lo-perks[data-has-offer="true"]');
    document.querySelectorAll('[data-lo-product-offer]').forEach(link => { link.hidden = !active; });
  };
  if (!customElements.get('lo-product-offer')) customElements.define('lo-product-offer', class extends HTMLElement { connectedCallback() { syncProductOffers(); } });
  document.addEventListener('lo:perks-ready', syncProductOffers);
  document.addEventListener('DOMContentLoaded', syncProductOffers, { once: true });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-lo-product-offer]');
    const perks = document.querySelector('lo-perks[data-has-offer="true"]');
    if (link && perks?.open) { event.preventDefault(); perks.open(link); }
  });
  syncProductOffers();
document.addEventListener('click',event=>{
  if(!(event.target instanceof Element))return;
  const link=event.target.closest('a[href="#lo-top"]');
  if(!link)return;
  event.preventDefault();
  window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
  } catch(e) { console.error(e); }
})();

})();
